'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { paywallTypes } from '@haaretz/s-consts';
import React from 'react';
const PaywallTypeContext = /*#__PURE__*/ React.createContext(undefined);
const PaywallTypeSetter = /*#__PURE__*/ React.createContext(undefined);
export function PaywallTypeProvider({ children, value: defaultPaywallType }) {
    const [paywallType, setPaywallType] = React.useState(defaultPaywallType);
    const paywallTypeSetter = React.useCallback((value)=>{
        const validatedPaywallType = paywallTypes.includes(value) ? value : 'premium';
        setPaywallType(validatedPaywallType);
    }, []);
    return /*#__PURE__*/ _jsx(PaywallTypeContext, {
        value: paywallType,
        children: /*#__PURE__*/ _jsx(PaywallTypeSetter, {
            value: paywallTypeSetter,
            children: children
        })
    });
}
export default function usePaywallType() {
    const context = React.use(PaywallTypeContext);
    if (context === undefined) {
        throw new Error('usePaywallType must be used within a PaywallTypeProvider');
    }
    return context;
}
export function useSetPaywallType() {
    const context = React.use(PaywallTypeSetter);
    if (context === undefined) {
        throw new Error('useSetPaywallType must be used within a PaywallTypeProvider');
    }
    return context;
}
export function usePaywallTypeAtom() {
    return [
        usePaywallType(),
        useSetPaywallType()
    ];
}

//# sourceMappingURL=paywallTypeAtom.js.map